module.exports = __webpack_public_path__ + "static/media/logo.e24f3190.png";